import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "textarea" ]

  append(event) {
    event.preventDefault()
    const name = (event.params.name || "").trim()
    if (!name) return

    const textarea = this.textareaTarget
    const lines = textarea.value.split("\n").map(line => line.trim()).filter(Boolean)
    if (lines.includes(name)) return

    const trailing = textarea.value.length > 0 && !textarea.value.endsWith("\n") ? "\n" : ""
    textarea.value = textarea.value + trailing + name + "\n"
    textarea.focus()
  }
}
